export default __webpack_public_path__ + "static/media/benefit_14@3x.bdb02874.png";